<template>
  <div class="upload-img-box" @paste="onPaste">
    <el-upload
        class="avatar-uploader"
        :action="uploadUrl"
        name="upload"
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
        :on-error="uploadError"
        accept="image/jpeg, image/png, image/jpg, image/gif"
        :style="{width: width,height: height}"
        ref="multipleUpload"
        :before-upload="beforeAvatarUpload"
        list-type="picture"
        :headers="header"
        :data="id ? {id: id}: {}"
    >
      <img v-if="cover" :src="imgURL"  class="avatar"/>
      <i v-else class="el-icon-plus avatar-uploader-icon" :style="{lineHeight: height}"></i>
    </el-upload>
    <p class="desc" v-if="isShow">图片大小最好不要超过2MB,且宽高度最好为{{ this.wSize + '*' + this.hSize }}</p>
  </div>
</template>
<script>
import baseConfig from "@/utils/serverUrlConfig";
import imageURLDecrypt from "@/components/imageURLDecrypt";

import local from "@/utils/localStroage";
import api from '@/api'

export default {
  data() {
    return {
      imgUrl: baseConfig.imgUrl,
      uploadUrl: baseConfig.baseServerUrl + "/vid/uploadStatic",
      cropperModel: false,
      // 当前选中的文件（未压缩裁剪之前）
      checkedFile: "",
      // 传递到裁剪框中的图片路径
      imgFile: "",
      imgURL: "",
      header: {
        Authorization: local.get("userInfo").token
      },
      lockImg: '',
    };
  },
  props: ["cover", "width", "height", "id", "wSize", "hSize", "hide"],
  computed: {
    isShow() {
      return this.hide ? false : true;
    }
  },


  async mounted() {
    this.$forceUpdate();
    if (this.$props.cover.startsWith('/')) {
      const tempURL = this.imgUrl + this.$props.cover;
      this.imgURL = await imageURLDecrypt(tempURL);
    } else {
      const tempURL = this.imgUrl + '/' + this.$props.cover;
      this.imgURL = await imageURLDecrypt(tempURL);
    }
  },
  destoryed() {
  },
  methods: {
    // // 图片上传前验证
    beforeAvatarUpload(file) {
      const isLt3M = file.size / 1024 / 1024 < 2;
      if (!isLt3M) {
        this.$message.error("封面上传大小不能超过2MB");
        return false
      }
    },
    // 视频封面上传成功回掉
    async handleAvatarSuccess(res) {
      if (res.code === 200) {
        const response = {...res}
        this.imgURL = await imageURLDecrypt(this.imgUrl + '/' + res.data.coverImg);
        this.$emit("successCallback", response);
      } else {
        this.$message.error("上传封面图失败");
      }
    },

    onPaste(event) {
      const items = (event.clipboardData || window.clipboardData).items
      let file = null
      if (!items || items.length === 0) {
        this.$message.error('当前浏览器不支持本地')
        return
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          file = items[i].getAsFile()
          break
        }
      }
      if (!file) {
        this.$message.error('粘贴内容非图片')
        return
      }
      // 此时file就是我们的剪切板中的图片对象
      this.file = file
      this.uploadPlans()
    },

    // 上传文件成功后回调
    uploadPlans() {
      const file = this.file
      if (!file) {
        this.$message.error('请粘贴图片后上传')
        return
      }
      this.loading = true
      const form = new FormData()
      form.append('upload', file)
      form.append('type', this.type)
      api.uploadImg(form).then((res) => {
        if (res.code === 200) {
          this.$message({
            type: 'success',
            message: '上传成功!'
          })
          this.lockImg = res.data.coverImg
          this.changeImgUrl()
        } else {
          this.$message({
            type: 'error',
            message: '上传失败!'
          })
          this.lockImg = ''
        }
      })
    },

    changeImgUrl() {
      this.$emit('changeImgUrl', this.lockImg)
    },

    // 图片上传错误
    uploadError() {
      this.$message.error("上传封面图失败");
    }
  }
};
</script>
<style lang="scss">
.dialog-popup {
  .el-dialog {
    margin-top: 0px !important;
  }
}

.upload-img-box {
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }

  .el-icon-plus {
    height: 100% !important;
  }

  img {
    width: 100%;
    height: 100%;
  }

  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
      border: 1px dashed #e63765;
    }
  }

  .desc {
    line-height: 1;
    margin-top: 10px;
    color: #810806;
    font-size: 12px;
  }

  .avatar-uploader-icon {
    width: 100%;
    height: 100%;
    font-size: 28px;
    color: #8c939d;
    line-height: 150px;
    text-align: center;

    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>

